import { CheckboxField, useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { useParams } from 'react-router-dom'

import {
  selectById as selectCalendarConnectionById,
  useFetchCalendarAccountsQuery,
  usePullCalendarsLimit
} from 'features/calendar_connections'

import { Option } from './styles'

const getHiddenLabel = (name, isHidden) => (isHidden
  ? `${I18n.t('publisher.availability_settings.section.calendar_settings.check_conflicts.popup.hidden_label', { name })}`
  : name)

export const Calendars = () => {
  const { id } = useParams()
  const { data } = useFetchCalendarAccountsQuery()
  const { kind, calendars } = selectCalendarConnectionById(data, id)
  const [_isLimited, isFieldDisabled] = usePullCalendarsLimit(kind, 'pullCalendarIds')
  const { values: { pullCalendarIds } } = useFormContext()
  const safeCalendars = calendars ?? []
  const safePullCalendarIds = pullCalendarIds ?? []

  const missingPullCalendarIds = safePullCalendarIds.filter(
    (pullCalendarId) => !safeCalendars.some((calendar) => calendar.id === pullCalendarId)
  )

  return (
    <div>
      {
        safeCalendars.map(({ id: calendarId, name, hidden }) => (
          <Option key={calendarId}>
            <CheckboxField
              name="pullCalendarIds"
              label={getHiddenLabel(name, hidden)}
              value={calendarId}
              disabled={isFieldDisabled(calendarId)}
            />
          </Option>
        ))
      }
      {
        missingPullCalendarIds.map((missingPullCalendarId) => (
          <Option key={missingPullCalendarId}>
            <CheckboxField
              name="pullCalendarIds"
              label={`${I18n.t(
                'publisher.availability_settings.section.calendar_settings.check_conflicts.popup.unsubscribed_label',
                { name: missingPullCalendarId }
              )}`}
              value={missingPullCalendarId}
              disabled={isFieldDisabled(missingPullCalendarId)}
            />
          </Option>
        ))
      }
    </div>
  )
}
